export default {
  moduleSearchResults: [],

  formIdFields: [],
}